export const COMPANY_ITCL_ADMIN_ROLES = ['System Admin', 'Admin', 'Accountant'];

export const isItclCompanyAdmin = (role) => COMPANY_ITCL_ADMIN_ROLES.includes(role);

export const isShipmentUnloaded = (row) => {
  const value = row?.unloaded;
  return value === true || value === 1 || value === 'true' || value === '1';
};

export const shipmentOnMlSheet = (row) => {
  if (!row) return false;
  if (row.on_ml_sheet) return true;
  const status = String(row.status || '');
  return status === 'Dispatched' || status === 'DISPATCHED';
};

export const isPendingUnloadRow = (row) => !isShipmentUnloaded(row) && !shipmentOnMlSheet(row);

export const itclRowActions = ({ role, unloaded, onMlSheet, canManage }) => {
  const isAdmin = isItclCompanyAdmin(role);
  const blocked = Boolean(onMlSheet);
  const isUnloaded = Boolean(unloaded);
  if (!canManage) {
    return {
      blocked,
      showUnload: false,
      showRevert: false,
      showRemove: false,
      showNote: false,
      canUnload: false,
      canRevert: false,
      canRemove: false,
      canNote: false,
    };
  }
  if (isAdmin) {
    return {
      blocked,
      showUnload: true,
      showRevert: true,
      showRemove: true,
      showNote: true,
      canUnload: !blocked && !isUnloaded,
      canRevert: !blocked && isUnloaded,
      canRemove: !blocked,
      canNote: true,
    };
  }
  return {
    blocked,
    showUnload: !isUnloaded,
    showRevert: isUnloaded,
    showRemove: !isUnloaded,
    showNote: true,
    canUnload: !blocked && !isUnloaded,
    canRevert: !blocked && isUnloaded,
    canRemove: !blocked && !isUnloaded,
    canNote: true,
  };
};

export const itclActionBlockedMessage = (actions, action) => {
  if (actions?.blocked) {
    return 'This shipment is already on an ML sheet, so unload / revert / remove is not allowed';
  }
  if (action === 'unload') {
    return 'Unload is available before the GC is unloaded';
  }
  if (action === 'revert') {
    return 'Revert is available after the GC is unloaded';
  }
  return 'This action is not available for this shipment';
};
